import React, { useState } from 'react';
import { useInView } from './useInView';
import './Experience.css';

const jobs = [
  {
    company: 'Mainflow Services and Tech',
    role: 'Full Stack Developer Intern',
    period: 'Feb 2025 – May 2025',
    type: 'Internship',
    points: [
      'Developed and validated RESTful APIs for seamless frontend-backend communication',
      'Architected normalized MySQL schema and optimized queries for improved data retrieval',
      'Established JWT-based authentication and role-based authorization mechanisms',
      'Collaborated in Agile sprints and code reviews aligned with SDLC best practices'
    ]
  },
  {
    company: 'CodTech IT Solutions',
    role: 'Web Development Intern',
    period: 'Jul 2024 – Sep 2024',
    type: 'Internship',
    points: [
      'Constructed responsive web interfaces with cross-browser compatibility',
      'Integrated frontend modules with backend REST APIs for dynamic content',
      'Enhanced UI maintainability through modular and reusable React components'
    ]
  },
  {
    company: 'Winjit Tech Pvt. Ltd.',
    role: 'AI Automation Intern',
    period: 'Sep 2022 – Dec 2022',
    type: 'Internship',
    points: [
      'Developed automation scripts to streamline repetitive business workflows',
      'Designed AI-driven logic integrations to reduce manual processing efforts'
    ]
  }
];

export default function Experience() {
  const [active, setActive] = useState(0);
  const [ref, visible] = useInView();

  return (
    <section className="section" id="experience">
      <div ref={ref} className={`fade-in${visible ? ' visible' : ''}`}>
        <p className="section-label">Experience</p>
        <h2 className="section-title">Where I've worked.</h2>
        <div className="exp-layout">
          <div className="exp-tabs">
            {jobs.map((j, i) => (
              <button
                key={i}
                className={`exp-tab${active === i ? ' active' : ''}`}
                onClick={() => setActive(i)}
              >
                <span className="tab-company">{j.company}</span>
                <span className="tab-period">{j.period}</span>
              </button>
            ))}
          </div>
          <div className="exp-content">
            <div className="exp-header">
              <div>
                <h3 className="exp-role">{jobs[active].role}</h3>
                <p className="exp-company">@ {jobs[active].company}</p>
              </div>
              <span className="exp-badge">{jobs[active].type}</span>
            </div>
            <p className="exp-period">{jobs[active].period}</p>
            <ul className="exp-list">
              {jobs[active].points.map((p, i) => (
                <li key={i}><span className="exp-dot">▹</span>{p}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
